module.exports = __webpack_public_path__ + "static/applegates-coaches-case-study-026d15e146aa3b169b8fd49816b7e434.jpg";